import apiClient from "./axiosClient";

export async function getRates() {
  const response = await apiClient.get("/exh/pairs/");
  return response.data.results;
}
